Ext.define('SA.model.createimport.UnreadableFile', {
    extend: 'SA.model.createimport.File'
});